import marketConfigService from '../../services/marketConfigService';

export const TERMS_OF_USE = 'WEB_TC';
export const WEB_PREFERENCE_CENTER = 'WEB_PREFERENCE_CENTER';

export const UNITED_TERMS_OF_USE = 'TERMS_OF_USE';
export const UNITED_WEB_PREFERENCE_CENTER = 'PREFERENCE_CENTER';

export const getTermsOfUseType = () => {
    const isPwaEnabled = marketConfigService.isUnitedTNCEnabled();

    return isPwaEnabled ? UNITED_TERMS_OF_USE : TERMS_OF_USE;
};

export const getPreferenceCenterType = () => {
    const isPwaEnabled = marketConfigService.isUnitedTNCEnabled();

    return isPwaEnabled ? UNITED_WEB_PREFERENCE_CENTER : WEB_PREFERENCE_CENTER;
};
